import { ADD_PROPERTY, DELETE_PROPERTY, REFRESH_PROPERTIES, UPDATE_PROPERTY } from "../actions/property.action";

const initialState = {
  properties: [],
};

// Helper function to sort properties by name
const sortPropertiesByName = (properties) => {
  return [...properties].sort((a, b) => {
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

const propertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_PROPERTIES:
      return {
        ...state,
        properties: sortPropertiesByName(action.properties),
      };
    case ADD_PROPERTY:
      return {
        ...state,
        properties: sortPropertiesByName([...state.properties, action.property]),
      };
    case UPDATE_PROPERTY:
      const updatedProperties = state.properties.map((property) =>
        property.id === action.property.id ? action.property : property
      );
      return {
        ...state,
        properties: sortPropertiesByName(updatedProperties),
      };
    case DELETE_PROPERTY:
      return {
        ...state,
        properties: state.properties.filter((property) => property.id !== action.propertyId),
      };
    default:
      return state;
  }
};

export default propertyReducer;
